module.exports = __webpack_public_path__ + "images/questions/qa_human_04_d0a12a037685c90711178a13ad5c8845.png";